import { ConstructPost } from '../../../types/ConstructPost';
import { ASSIGNMENT_QUEUE_BASE_PATH } from '../constants/assignmentQueueBasePath';
import { AssignQueuePayload } from '../types/AssignmentQueue';

export const postAssignToQueue = async (
  constructPost: ConstructPost,
  data: AssignQueuePayload,
): Promise<undefined> =>
  constructPost<undefined>(
    `${ASSIGNMENT_QUEUE_BASE_PATH}/assign`,
    { data },
    { preventDefaultErrorToast: true },
  );
